import { defineMessages } from 'react-intl';

export default defineMessages({
  youBorrowed: 'You borrowed',
  walletBalance: 'Wallet balance',
  yourCollateral: 'Your collateral',
  loanToValue: 'Loan to value',
});
